import axios from '@/axiosInterceptor';
import {
  extractResponseType,
  extractState,
  extractClientId,
  extractScope,
  extractRedirectUri,
} from '@/common/localStorage';

const state = () => ({
  connections: [],
  logo: {},
  company: {},
  is_logo_loading: false,
  availableConnections: [],
  localStorage: {
    scope: null,
    response_type: null,
    redirect_url_after_sigin: null,
    redirect_uri: null,
    state: null,
    client_id: null,
  },
});

// getters
const getters = {};

// actions

const actions = {
  async getBrokers({ commit }, { query = '' }) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/companies/my_brokers' + query
      );
      commit('setConnections', res.data);
      commit('loading/loadingToggleOff', null, { root: true });
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getLogoByClientId({ commit }, clientId) {
    if (!clientId) return;
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/companies/public_details?oauth_uid=' +
          clientId
      );
      commit('setLogo', res?.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getLogoByCompanyId({ commit }, company_id) {
    if (!company_id) return;
    try {
      commit('setLogoLoading', true);

      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/companies/public_details?company_id=' +
          company_id
      );
      commit('setLogo', res?.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    } finally {
      commit('setLogoLoading', false);
    }
  },
  async getCompanyById({ commit }, company_id) {
    if (!company_id) return;
    try {
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/companies/' + company_id
      );
      commit('setCompany', res?.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getAvailableConnections({ commit }) {
    try {
      const res = await axios.get(
        `${process.env.API_IDENTITY}/api/v1/companies?q[oauth_application_is_public_to_carriers_true]=1&show_logos=1`
      );
      commit('setAvailableConnections', res.data);
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async updateLocalStorage({ dispatch, commit }, url) {
    localStorage.setItem('scope', extractScope(url));
    localStorage.setItem('response_type', extractResponseType(url));
    // localStorage.setItem('redirect_url_after_sigin', JSON.stringify(url));
    localStorage.setItem('redirect_uri', extractRedirectUri(url));
    localStorage.setItem('state', extractState(url));
    localStorage.setItem('client_id', extractClientId(url));
    commit('setLocalStorage', localStorage);
    dispatch('getLogoByClientId', localStorage.getItem('client_id'));
  },
};

//mutations
const mutations = {
  setConnections(state, el) {
    state.connections = el;
  },
  setLogo(state, el) {
    state.logo = el;
  },
  setCompany(state, data) {
    state.company = data;
  },
  setLogoLoading(state, boolean) {
    state.is_logo_loading = boolean;
  },
  setAvailableConnections(state, el) {
    state.availableConnections = el;
  },
  setLocalStorage(state, ls) {
    state.localStorage.scope = ls['scope'];
    state.localStorage.response_type = ls['response_type'];
    // state.localStorage.redirect_url_after_sigin = ls['redirect_url_after_sigin'];
    state.localStorage.redirect_uri = ls['redirect_uri'];
    state.localStorage.state = ls['state'];
    state.localStorage.client_id = ls['client_id'];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
